export const FETCH_DASHBOARD_ACTIVITY_LIST_REQUEST =
  "FETCH_DASHBOARD_ACTIVITY_LIST_REQUEST";
export const FETCH_DASHBOARD_ACTIVITY_LIST_SUCCESS =
  "FETCH_DASHBOARD_ACTIVITY_LIST_SUCCESS";
export const FETCH_DASHBOARD_ACTIVITY_LIST_FAILURE =
  "FETCH_DASHBOARD_ACTIVITY_LIST_FAILURE";

export const FETCH_DASHBOARD_DATE_RANGE_LIST_REQUEST =
  "FETCH_DASHBOARD_DATE_RANGE_LIST_REQUEST";
export const FETCH_DASHBOARD_DATE_RANGE_LIST_SUCCESS =
  "FETCH_DASHBOARD_DATE_RANGE_LIST_SUCCESS";
export const FETCH_DASHBOARD_DATE_RANGE_LIST_FAILURE =
  "FETCH_DASHBOARD_DATE_RANGE_LIST_FAILURE";

export const FETCH_DASHBOARD_AVG_DETAILS_REQUEST =
  "FETCH_DASHBOARD_AVG_DETAILS_REQUEST";
export const FETCH_DASHBOARD_AVG_DETAILS_SUCCESS =
  "FETCH_DASHBOARD_AVG_DETAILS_SUCCESS";
export const FETCH_DASHBOARD_AVG_DETAILS_FAILURE =
  "FETCH_DASHBOARD_AVG_DETAILS_FAILURE";
